var map = {
	"./0059_unicorn.mp4": 9680,
	"./0062__38mb.mp4": 9094,
	"./0067_16.9_30sec.mp4": 1880,
	"./0068_30sec.mp4": 8541,
	"./0081_1_RSlots_JapanScreen.mp4": 7737,
	"./080_1_Mexico_screen.mp4": 7001,
	"./083_1_3MainScreens.mp4": 764,
	"./bazooka.jpg": 3695,
	"./japan.jpg": 5574,
	"./mexico.jpg": 493,
	"./noob.jpg": 6780,
	"./noob2.jpg": 4620,
	"./party.jpg": 5943,
	"./royal.jpg": 8006,
	"./slots_party.mp4": 9206,
	"./team.jpg": 9673,
	"./unicorn.jpg": 7478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1366;